import React from 'react';

import { Wrapper } from './search-result-header.styles';

const SearchResultHeader = ({ searchResultsCount }) => {
  return <Wrapper>Результаты поиска ({searchResultsCount})</Wrapper>;
};

export default SearchResultHeader;
